import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { withFacetContext } from '../hocs/facet.context.hoc'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { rangeMax, rangeMin } from './static-props'
import { ariaLabel } from '../../utils/form-utilities'
import { SearchFiltersCheckboxes } from '../../components/search-filters-checkbox/search-filters-checkboxes'

const SeatsMin = withFilterContext(FilterName.min_seats, SearchFiltersDropdown, {
    ...rangeMin,
    ariaLabel: ariaLabel.seats.min,
})
const SeatsMax = withFilterContext(FilterName.max_seats, SearchFiltersDropdown, {
    ...rangeMax,
    ariaLabel: ariaLabel.seats.max,
})

export const SeatsMaxFacetAndFilter = withFacetContext(FacetName.seats, SeatsMax)
export const SeatsMinFacetAndFilter = withFacetContext(FacetName.seats, SeatsMin)

export const Seats = withFacetContext(
    FacetName.seats_values,
    withFilterContext(FilterName.seats_values, SearchFiltersCheckboxes, {
        title: 'Seats',
        moreOptionsLabel: 'More seats',
    })
)
